import {
    type CreateOldPresidentResponseType,
    type CreateOldPresidentRequestType
} from "./type";
import {
    request
} from "../request";

const createOldPresident = async (params: CreateOldPresidentRequestType): Promise<CreateOldPresidentResponseType> => {
    return await request<CreateOldPresidentResponseType>("/content/createOldPresident", {
        body: JSON.stringify(params),
        method: "POST"
    });
};
export default createOldPresident;
